import React from "react";
import { Target, Users, AlertTriangle, Zap } from "lucide-react";
import MetricTooltip from "./MetricTooltip";

const CompactMetricsBar = ({ stats, isDarkMode }) => {
  if (!stats) return null;

  const metrics = [
    {
      icon: Target,
      label: "Trainability",
      value: `${Number(stats.avg_team_trainability).toFixed(1)}/10`,
      color: "emerald",
      tooltip: "Average team training capacity index. Reflects muscle recovery and physiological availability of players.",
    },
    {
      icon: Users,
      label: "Optimal",
      value: stats.optimal_readiness_count,
      color: "indigo",
      tooltip: "Number of players with readiness ≥75%. These players are in optimal condition to handle high training loads.",
    },
    {
      icon: AlertTriangle,
      label: "At Risk",
      value: stats.players_at_risk,
      color: "rose",
      tooltip: "Players with high injury risk (trainability <4/10). Require load adaptation or rest.",
    },
  ];

  const colorMap = {
    emerald: isDarkMode ? "text-emerald-400" : "text-emerald-600",
    indigo: isDarkMode ? "text-indigo-400" : "text-indigo-600",
    rose: isDarkMode ? "text-rose-400" : "text-rose-600",
    amber: isDarkMode ? "text-amber-400" : "text-amber-600",
  };

  return (
    <div className="flex items-center gap-4 flex-wrap">
      {metrics.map((m, idx) => (
        <MetricTooltip key={idx} content={m.tooltip} isDarkMode={isDarkMode}>
          <div className="flex items-center gap-2 cursor-help">
            <m.icon size={14} className={colorMap[m.color]} />
            <span className={`text-xs ${isDarkMode ? "text-gray-400" : "text-gray-500"}`}>
              {m.label}
            </span>
            <span className={`text-sm font-bold ${colorMap[m.color]}`}>{m.value}</span>
          </div>
        </MetricTooltip>
      ))}
    </div>
  );
};

export default CompactMetricsBar;
